import React from 'react';
import YogaServiceCard from './YogaServiceCard';
import ContactButton from '../common/ContactButton';

const YogaServices = ({ yogaData, onContactClick }) => {
    return (
        <div className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h1 className="text-4xl font-light text-gray-900 mb-4">
                        {yogaData?.title || 'Yoga Services'}
                    </h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                        Discover inner peace and strength through personalized yoga sessions designed for your unique journey.
                    </p>
                    <ContactButton
                        text="Schedule Your Session"
                        inquiryType="Yoga Consultation"
                        prefilledData={{
                            message: "I'm interested in learning more about your yoga services and would like to schedule a consultation.",
                            serviceDetails: "Initial consultation for yoga services"
                        }}
                        onClick={onContactClick}
                        className="mx-auto"
                    />
                </div>

                <div className="space-y-12 mb-16">
                    {yogaData?.services?.map((service) => (
                        <YogaServiceCard
                            key={service.id}
                            service={service}
                            onContactClick={onContactClick}
                        />
                    ))}
                </div>

                <div className="text-center">
                    <ContactButton
                        text="Schedule Your Session"
                        inquiryType="Private Yoga Session"
                        prefilledData={{
                            message: "I would like to schedule a private yoga session. Please let me know your availability.",
                            serviceDetails: "Private yoga session booking"
                        }}
                        onClick={onContactClick}
                        className="mx-auto"
                    />
                </div>
            </div>
        </div>
    );
};

export default YogaServices;